import { Controller } from "@hotwired/stimulus"

// 「上記対象者に配信することを確認しました」 チェックが入るまで送信ボタンを disable にする。
// submit ボタン側に data-disabled-reason があればそれをタイトル属性に付与する ( 送信対象 0 名などの理由表示用 )。
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    const reason = this.submitTarget.dataset.disabledReason
    if (reason) {
      this.submitTarget.disabled = true
      this.submitTarget.title = reason
      return
    }
    this.submitTarget.disabled = !this.checkboxTarget.checked
  }
}
